<template>
  <div class="px-6 py-4 border bg-gray-100 sm:rounded-lg">
    <h3 class="text-base leading-6 font-medium text-vice-teal-700">
      <slot></slot>
    </h3>
  </div>
</template>

<script>
export default {
  name: 'CardHeader',
};
</script>
